import Image from 'next/legacy/image';
import { CurrentUser, CustomerProfile } from 'types';
import { USER_BACKGROUND_PLACEHOLDER_LINK } from 'consts';
import { RatingMark } from 'components/RatingMark';
import { UserPhoto } from 'components/UserPhoto';
import { UserProfileHeaderBar } from './UserProfileHeaderBar';
import { TabType } from './tabsMap';

import styles from './UserProfile.module.scss';
import { NextIcon } from '../../components/NextImage';

export type HeaderProps = {
  user?: CurrentUser;
  profile: CustomerProfile;
  activeTab: TabType;
  onChangeTab: (tab: TabType) => void;
  onFollow: () => void | boolean;
  onSendReport?: () => void;
  onBlock?: (block: boolean) => void;
};

export const UserProfileHeader = ({ user, profile, activeTab, onChangeTab, onFollow, onSendReport, onBlock }: HeaderProps) => {
  return (
    <div className={styles.headerWrapper}>
      <div className={styles.coverWrapper}>
        <div className={styles.coverImageForeground}/>
        <Image
          src={profile.cover_image || USER_BACKGROUND_PLACEHOLDER_LINK}
          alt="cover image"
          layout="fill"
          objectFit="cover"
        />
        <div className={styles.photoWrapper}>
          <UserPhoto src={profile.photo || ''} alt={profile.username} layout="fill" objectFit="cover" />
        </div>
        <div className={styles.userName}>{profile.is_deleted ? 'Deleted User' : (profile.account_type==='business' ? profile.business_name : profile.full_name)}</div>
        {!profile.is_deleted && (
          <div className={styles.userDetails}>
            @{profile.username} &#8226; {`${profile.location_city}, ${profile.location_state}`}{' '}
            {(profile.location_country === 'CAN' || profile.location_country === 'CA') && (
              <>
                &nbsp;
                <NextIcon src="/icons/Maple.svg" size={32} />
                &nbsp;
              </>
            )}
            {profile.is_ambassador ? <>&#8226; Ambassador</> : profile.rate_count ? (
              <>
                &#8226; &nbsp; <RatingMark value={+(profile.rate || 0)} />
                &nbsp; {profile.rate_count}
              </>
            ) : (
              ''
            )}
          </div>
        )}
      </div>
      <UserProfileHeaderBar
        user={user}
        profile={profile}
        activeTab={activeTab}
        onChangeTab={onChangeTab}
        onFollow={onFollow}
        onSendReport={onSendReport}
        onBlock={onBlock}
      />
    </div>
  );
};
